import types from '../constants'

// Dispatch after storage.saveInfo on a service/station switch. Clears
// station-scoped redux state and invalidates in-flight station requests.
export const switchStation = ({ serviceId, stationId } = {}) => ({
  type: types.SWITCH_STATION,
  serviceId,
  stationId,
})
